import React from 'react';
import ReactDOM from 'react-dom';
import store from './store';
import { Provider } from 'react-redux';

import './index.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-table-v6/react-table.css';
import './styles/css/style.css';
// import 'react-notifications/lib/notifications.css'
// import UpdatePrice from './components/dashboard/update-price';

import { getTracker } from './tracker';
import App from './App';

//initialize tracker
getTracker().initialize('75a64a55d941d0b5d887cfd0c4c12eff', 'PROD');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,

  document.getElementById('root')
);
